// extracted by mini-css-extract-plugin
export default {"signup_layout":"signupLayout_signup_layout__7lWT4","content":"signupLayout_content__nIrSX","row":"signupLayout_row__AA+Eu","col":"signupLayout_col__KYz2T"};